import { Answer as AnswerItem } from './Answer';

export default AnswerItem;
